module.exports = __webpack_public_path__ + "email_70x70.1cb88d9febe89eb474f3ad4903fc5508.png";